import { ReactNode, FC } from 'react'

import { Box, SxProps, Theme, Typography } from '@mui/material'

interface InfoCardProps {
  title: string
  mainValue: number
  children: ReactNode
  icon: ReactNode
  iconColor: string
  iconBgColor: string
  wrapperSx?: SxProps<Theme>
}

const InfoCard: FC<InfoCardProps> = ({
  title,
  mainValue,
  children,
  icon,
  iconColor,
  iconBgColor,
  wrapperSx,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: 1,
        flex: 1,
        minWidth: '200px',
        borderRadius: '4px',
        position: 'relative',
        backgroundColor: '#fff',
        p: '16px',
        boxShadow: '0px 2px 10px 2px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        ...wrapperSx,
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: '#797D80',
            fontSize: '14px',
            fontWeight: 500,
            mb: 1,
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: iconColor,
            fontSize: 24,
            width: 40,
            height: 40,
            borderRadius: 2,
            backgroundColor: iconBgColor,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          }}
        >
          {icon}
        </Box>
      </Box>

      <Typography
        variant="h4"
        sx={{
          fontSize: '22px',
          fontWeight: 700,
          color: '#222b45',
          mb: 1,
          lineHeight: 1.2,
        }}
      >
        {mainValue}
      </Typography>

      <Box sx={{ mt: 'auto' }}>{children}</Box>
    </Box>
  )
}
export default InfoCard
